export default function mapFontsToLanguages(langEnums, fontEnums) {
  return langEnums.map((lang) => {
      let language = fontEnums.find((e) => e.locale_code === lang.value);
      if (language?.font) {
          lang.font = language.font;
      }
      return lang;
  })
};
